module.exports = __webpack_public_path__ + "img/jbt9162_18_1999.prt.1f62aa4a.jpg";